import React from 'react';
import RadioGroup from './radio_group';
import { Alert, Col, ControlLabel, Row } from 'react-bootstrap';
import cx from 'classnames';
import style from './style.module.scss';
import { PaymentMethod, PaymentStyle, StripePaymentFormGroupProps } from '../types';
import stripeLogo from './assets/powered_by_stripe.svg';
import StripeCardInputs from '@magoosh/pages/payment_flows/subscription_form/stripe_card_inputs';

export const StripePaymentFormGroup: React.FC<StripePaymentFormGroupProps> = ({
  values,
  setFieldValue,
  formattedDiscountPrice,
  paymentRequestMethod,
  errors
}) => {
  const disabledPaymentsHint = paymentRequestMethod
    ? `Select “Pay full ${formattedDiscountPrice} today” to pay with Paypal, Alipay or ${paymentRequestMethod}`
    : `Select “Pay full ${formattedDiscountPrice} today” to pay with Paypal or Alipay`;

  const paymentOptions = [
    {
      icons: ['fa fa-cc-visa', 'fa fa-cc-mastercard', 'fa fa-cc-discover', 'fa fa-cc-amex'],
      value: PaymentMethod.STRIPE
    },
    {
      icons: ['fa fa-cc-paypal'],
      value: PaymentMethod.PAYPAL,
      disabled: values.paymentStyle === PaymentStyle.INSTALLMENTS,
      hint: values.paymentStyle === PaymentStyle.INSTALLMENTS && disabledPaymentsHint
    },
    {
      icons: ['sprite sprite-alipay subscription-payment-sprite'],
      value: PaymentMethod.ALIPAY,
      disabled: values.paymentStyle === PaymentStyle.INSTALLMENTS
    }
  ];
  if (paymentRequestMethod) {
    let iconName = 'sprite';
    if (paymentRequestMethod == 'Google Pay') {
      iconName += ' sprite-google-pay';
    } else if (paymentRequestMethod == 'Apple Pay') {
      iconName += ' sprite-apple-pay';
    }

    paymentOptions.push({
      icons: [iconName],
      value: PaymentMethod.STRIPE_PAYMENT_REQUEST,
      disabled: values.paymentStyle === PaymentStyle.INSTALLMENTS
    });
  }
  return (
    <div className="form-group">
      <fieldset className="inputs">
        <legend className={style.noMargin}>
          <span>Payment Method</span>
        </legend>
        <Row className="form-group">
          <Col md={8}>
            <RadioGroup
              name="paymentMethod"
              optionsArray={paymentOptions}
              selected={values.paymentMethod}
              onChange={(newValues) => {
                setFieldValue('paymentMethod', newValues);
              }}
              className={cx(style.payments, 'radio-inline')}
            />

            {values.paymentMethod === PaymentMethod.STRIPE && <StripeCardInputs errors={errors} />}

            {values.paymentMethod === PaymentMethod.PAYPAL && (
              <Alert bsStyle="secondary">
                Payment will be collected on PayPal&apos;s site after you complete your order
              </Alert>
            )}

            {(values.paymentMethod === PaymentMethod.ALIPAY ||
              values.paymentMethod === PaymentMethod.STRIPE_PAYMENT_REQUEST) && (
              <Alert bsStyle="secondary">
                Payment will be collected after you click &quot;Continue to Payment&quot;
              </Alert>
            )}
          </Col>
          <Col md={4} className={cx(style.paypalImage, 'hidden-sm hidden-xs')}>
            <a href="http://www.stripe.com" target="_blank" rel="noopener noreferrer">
              <img alt="Powered by Stripe" src={stripeLogo}></img>
            </a>
          </Col>
        </Row>
      </fieldset>
    </div>
  );
};

export default StripePaymentFormGroup;
